import axios from "axios";
import ConstantList from "../appConfig";
// đồng bộ dữ liệu sang crm
const API_PATH = ConstantList.API_EN_POINT + "/sync-crm";
const API_PATH_BASE = ConstantList.API_EN_POINT + "/";

export const syncListFeeToCrm = (searchObject) =>
  axios.post(API_PATH + "/sync-list-billing-to-crm", searchObject);

export const removeListFeeToCrm = (searchObject) =>
  axios.post(API_PATH + "/remove-list-billing-to-crm", searchObject);

export const syncListCheckInToCrm = (searchObject) =>
  axios.post(API_PATH + "/sync-list-checkin-to-crm", searchObject);

export const removeListCheckInToCrm = (searchObject) =>
  axios.post(API_PATH + "/remove-list-checkin-to-crm", searchObject);

export const syncCard = (serachObject) =>
  axios.post(API_PATH + "/sync-list-treatment-plan-card-to-crm", serachObject);

export const syncService = (searchObject) =>
  axios.post(API_PATH + "/sync-list-service-to-crm", searchObject);

export const removeService = (searchObject) =>
  axios.post(API_PATH + "/remove-list-service-to-crm", searchObject);

export const removeCard = (searchObject) =>
  axios.post(API_PATH + "/remove-list-card-to-crm", searchObject);

export const removeProduct = (searchObject) =>
  axios.post(API_PATH + "/remove-list-product-to-crm", searchObject);

export const syncTreament = (searchObject) =>
  axios.post(API_PATH + "/sync-list-sv-item-to-crm", searchObject);
// db khach hang
export const syncListPatientToCrm = (searchObject) =>
  axios.post(API_PATH + "/sync-list-patient-to-crm", searchObject);
// db sp
export const syncListProductToCrm = (searchObject) =>
  axios.post(API_PATH + "/sync-list-product-to-crm", searchObject);
// db xoa dieu tri
export const removeTreament = (searchObject) =>
  axios.post(
    API_PATH + "/remove-list-service-request-item-to-crm",
    searchObject
  );

export const syncListAppointmentToCrm = (searchAppointment) =>
  axios.post(API_PATH + "/sync-list-appointment-to-crm", searchAppointment);

export const elasticCrmEmrSyncLog = (searchAppointment) =>
  axios.post(
    API_PATH_BASE + "elastic-crm-emr-sync-log/elastic-paging",
    searchAppointment
  );

export const resendLog = (logId) =>
  axios.get(API_PATH_BASE + `elastic-crm-emr-sync-log/resend/${logId}`);

export const getLogById = (logId) =>
  axios.get(API_PATH_BASE + `elastic-crm-emr-sync-log/${logId}`);

export const saveLogEmr = (obj) =>
  axios.post(API_PATH_BASE + `elastic-crm-emr-sync-log/save`, obj);
